import React, { useEffect } from "react";
import "./App.css";
import Header from "./Header";
import Home from "./Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Checkout from "./Checkout";
import Login from "./Login";
import { auth } from "./firebase";
//import { useStateValue } from "./StateProvider";
import Payment from "./Payment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from "./Orders";
import Footer from "./Footer";
import SignUp from "./SignUp";
import { useSelector, useDispatch } from "react-redux";
import { setUser, logout, selectUser } from "./redux/cart/cartSlice";

const promise = loadStripe(
  "pk_test_51HQp74IGW7F8CVWPP9T6S2gPRdvqkHy1fQtFL0Rt7bBZqqeB67cn8xioTTI9a2b6e2XqFlVErRyb3NrtlbTIIH9G00hlaV1s8w"
);

function App() {
  console.log("Enter App Page");
  //const [{ basket }, dispatch] = useStateValue();
  //below line get the user from data layer
  const { user, basket } = useSelector(selectUser);
  const dispatch = useDispatch();
  //session use in the app
  //sessionStorage.setItem("test", JSON.stringify({ state.basket }));
  //console.log("In session", JSON.parse(sessionStorage.getItem("test")));
  ///end session
  useEffect(() => {
    console.log("Enter App Page Useeffect");
    auth.onAuthStateChanged((authUser) => {
      console.log("The user is ", authUser);
      if (authUser) {
        //the user just loggin in / the user was logged in
        //on page refresh after login keep up login
        /*dispatch({
          type: "SET_USER",
          user: authUser,
        });*/

        dispatch(setUser({ username: authUser }));
        console.log("user in", authUser);
      } else {
        // the user is logged out
        /*dispatch({
          type: "SET_USER",
          user: null,
        });*/
        dispatch(logout());
        console.log("user out", authUser);
      }
    });
  }, [dispatch]);
  console.log("User in App Page", user);
  console.log("Basket in App Page", basket);
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/signup">
            <SignUp />
          </Route>
          <Route path="/checkout">
            <Header />
            <Checkout />
          </Route>
          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
          </Route>
          <Route path="/orders">
            <Header />
            <Orders />
          </Route>
          <Route path="/">
            <Header />
            <Home />
            <Footer />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
